import type { FC } from "react"
import { useState } from "react"
import IconButton from "@mui/material/IconButton"
import Tooltip from "@mui/material/Tooltip"
import CloudDownloadIcon from "@mui/icons-material/CloudDownload"
import { useTheme } from "@mui/system"
import { useTranslation } from "react-i18next"

import type { EntityType } from "types/common.types"
import CsvDownloadDrawer from "./CsvDownloadDrawer"

export interface CSVButtonProps {
  entity?: EntityType
}

const CsvButton: FC<CSVButtonProps> = ({ entity = "device" }) => {
  const { t } = useTranslation()
  const theme = useTheme()
  const [open, setOpen] = useState(false)

  return (
    <>
      <Tooltip title={t("table.DOWNLOAD_RAW_CSV")}>
        <span>
          <IconButton
            onClick={() => setOpen(true)}
            sx={{
              height: "38px",
              width: "38px",
              border: `1px solid ${theme.palette.neutral[400]}`,
              borderRadius: 1,
              "&:hover": {
                borderColor: theme.palette.primary.main,
                transition: "all 0.5s ease",
              },
            }}
          >
            <CloudDownloadIcon fontSize="small" />
          </IconButton>
        </span>
      </Tooltip>
      <CsvDownloadDrawer open={open} onClose={() => setOpen(false)} entity={entity} />
    </>
  )
}

export default CsvButton
